import React, { ReactNode, MouseEvent } from 'react'
import './base-content-box.css'

/**
 * Props to use when initializing a `ContentBox` component.
 */
export interface BaseContentBoxProps {
  /**
   * a node to be rendered in the special component.
   */
  children?: ReactNode
  customWidth?: number | string
  className?: string
}

/**
 * Content box for PTCS apps.
 */
export function BaseContentBox({ children, customWidth, className }: BaseContentBoxProps) {
    return (
    <div className={`base-container ${className}`} style={{width: customWidth || 388}}>
      {children}
    </div>
  )
}
